import React from "react";
import update from "immutability-helper";
import client from "lib/apolloClient/client";
import _ from "lodash";
import {
  createRoutineTemplateMutation,
  deletePostTemplateMutation,
  importPostTemplateData,
  updatePostTemplateMutation,
} from "./RoutineTemplatesMutations";
import {
  formatMappedCourses,
  formatMappedCoursesWithCourseData,
  formatMappedEntitiesUpdateInput,
  formatTemplateFieldsUpdateInput,
  getMappedMealMenus,
  transformFieldDataSets,
} from "../utils";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
export const NAME = "routineTemplates";
export const UPDATE_TEMPLATE_FIELDS = "UPDATE_TEMPLATE_FIELDS" + " " + NAME;
export const ADD_NEW_FIELD = "ADD_NEW_FIELD" + " " + NAME;
export const REPLACE_FIELD = "REPLACE_FIELD" + " " + NAME;
export const ADD_NEW_OPTION = "ADD_NEW_OPTION" + " " + NAME;
export const UPDATE_OPTION_VALUE = "UPDATE_OPTION_VALUE" + " " + NAME;
export const UPDATE_OPTIONS = "UPDATE_OPTIONS" + " " + NAME;
export const UPDATE_FIELD_ENTITIES = "UPDATE_FIELD_ENTITIES" + " " + NAME;
export const UPDATE_METADATA = "UPDATE_METADATA" + " " + NAME;
export const UPDATE_FIELD_DATASET = "UPDATE_FIELD_DATASET" + " " + NAME;
export const DELETE_OPTION = "DELETE_OPTION" + " " + NAME;
export const DELETE_FIELD = "DELETE_FIELD" + " " + NAME;
export const SWAP_FEILDS = "SWAP_FIELDS" + " " + NAME;
export const RESET_TEMPLATE = "RESET_TEMPLATE" + " " + NAME;
export const UPDATE_FILTERS = "UPDATE_FILTERS" + " " + NAME;
export const UPDATE_MEAL_MENUS = "UPDATE_MEAL_MENUS" + " " + NAME;
export const DELETE_MEAL_MENU = "DELETE_MEAL_MENU" + " " + NAME;
export const UPDATE_CLASSES = "UPDATE_CLASSES" + " " + NAME;
export const RESET_CLASSES = "RESET_CLASSES" + " " + NAME;
export const RESET_FILTERS = "RESET_FILTERS" + " " + NAME;
export const SET_ALL_CLASSES_SELECTED = "SET_ALL_CLASSES_SELECTED" + " " + NAME;
const initialState = {
  templateFields: [],
  filters: {
    searchText: "",
    tableSearchText: "",
    grades: [],
    classes: [],
  },
  mappings: {
    classes: [],
  },
  isAllClassesSelected: false,
  isEditMode: false,
};

export const updateFilters = updatedFilters => {
  return {
    type: UPDATE_FILTERS,
    data: updatedFilters,
  };
};

export const updateClasses = updatedClasses => {
  return {
    type: UPDATE_CLASSES,
    data: updatedClasses,
  };
};

export const setAllClassesSelected = value => {
  return {
    type: SET_ALL_CLASSES_SELECTED,
    data: value,
  };
};

export const resetClassFilters = () => {
  return {
    type: RESET_FILTERS,
  };
};

export const resetClasses = () => {
  return {
    type: RESET_CLASSES,
  };
};

export const createPostRoutineTemplate = ({
  templateData,
  closeCreateTemplate,
  reset,
}) => {
  return async (dispatch, getState) => {
    try {
      const variables = {
        input: templateData,
      };
      const res = await client.mutate({
        mutation: createRoutineTemplateMutation,
        variables,
      });
      const { isSuccess, warning = {} } =
        _.get(res, "data.documentation.createPostTemplate", false) || {};
      if (isSuccess) {
        dispatch(
          setToastMsg({
            msg: "journal:tempate_successfully_created",
            type: "success",
          })
        );
        closeCreateTemplate({ refetch: true, reset });
      }

      return _.get(res, "data.documentation.createPostTemplate", false);
    } catch (e) {
      closeCreateTemplate?.({ refetch: false });
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateRoutineTemplate = ({
  isNewTemplateRequired,
  templateMetaData,
  oldTemplateData,
  updatedTemplateData,
  closeCreateTemplate,
  archiveOldTemplate,
}) => {
  return async (dispatch, getState) => {
    try {
      const variables = {
        input: {
          ...templateMetaData,
          ...(!isNewTemplateRequired
            ? {
                fields: formatTemplateFieldsUpdateInput({
                  templateFields: updatedTemplateData,
                  oldTemplateFields: oldTemplateData,
                }),
              }
            : {}),
        },
      };
      const res = await client.mutate({
        mutation: updatePostTemplateMutation,
        variables,
      });
      const { isSuccess } =
        _.get(res, "data.documentation.updatePostTemplate", false) || {};
      if (isSuccess && !isNewTemplateRequired) {
        archiveOldTemplate?.();
        dispatch(
          setToastMsg({
            msg: "journal:template_successfully_updated",
            type: "success",
          })
        );
      }
      closeCreateTemplate?.({ refetch: true, reset: false });
      return _.get(res, "data.documentation.updatePostTemplate", null);
    } catch (e) {
      closeCreateTemplate?.({ refetch: false });
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateTemplateClasses = ({
  newClasses,
  oldClasses,
  templateId,
  refetchTemplates,
  isNewTemplateRequired,
  curriculumProgramId,
  isAllClassesSelected,
  archiveOldTemplate,
}) => {
  return async (dispatch, getState) => {
    try {
      const variables = {
        input: {
          id: templateId,
          state: "PUBLISHED",
          ...(!isNewTemplateRequired
            ? formatMappedEntitiesUpdateInput({
                isAllClassesSelected,
                curriculumProgramId,
                newMappedEntities: formatMappedCourses(newClasses),
                oldMappedEntities: formatMappedCoursesWithCourseData(
                  oldClasses
                ),
              })
            : { state: "ARCHIVED" }),
        },
      };
      const res = await client.mutate({
        mutation: updatePostTemplateMutation,
        variables,
      });
      const { isSuccess } =
        _.get(res, "data.documentation.updatePostTemplate", false) || {};
      if (isSuccess) {
        archiveOldTemplate?.();
        if (!isNewTemplateRequired) {
          dispatch(
            setToastMsg({
              msg: "journal:template_successfully_updated",
              type: "success",
            })
          );
        }
        refetchTemplates();
      }
      return res;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const deleteRoutineTemplate = ({
  ids,
  refetchTemplates,
  hideToast = false,
}) => {
  return async (dispatch, getState) => {
    try {
      const variables = {
        input: {
          ids,
        },
      };
      const res = await client.mutate({
        mutation: deletePostTemplateMutation,
        variables,
      });
      const { isSuccess } =
        _.get(res, "data.documentation.deletePostTemplate", false) || {};
      if (isSuccess) {
        if (!hideToast) {
          dispatch(
            setToastMsg({
              msg: "journal:template_successfully_deleted",
              type: "success",
            })
          );
        }
        refetchTemplates?.();
      }
      return res;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const importRoutineTemplate = ({ templateId }) => {
  return async (dispatch, getState) => {
    try {
      const variables = {
        input: {
          templateId,
        },
      };
      const res = await client.mutate({
        mutation: importPostTemplateData,
        variables,
      });
      return _.get(res, "data.documentation.importPostTemplate", {});
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const routineTemplatesReducer = (state, action) => {
  const { type, payload } = action;
  const { templateFields: originalFields } = state;
  const fields = _.cloneDeep(originalFields);
  switch (type) {
    case UPDATE_TEMPLATE_FIELDS: {
      const { templateFields } = payload;
      const transformedPayload = transformFieldDataSets(templateFields);
      const mappedMealMenus = getMappedMealMenus(templateFields);
      return update(state, {
        templateFields: { $set: transformedPayload },
        mealMenus: { $set: mappedMealMenus },
        isEditMode: { $set: true },
      });
    }
    case ADD_NEW_FIELD: {
      fields.push(payload);
      return update(state, {
        templateFields: { $set: fields },
      });
    }
    case REPLACE_FIELD: {
      const { fieldId, field } = payload;

      const fieldIndex = _.findIndex(
        state.templateFields,
        fieldItem => fieldItem.id === fieldId
      );

      const displaySequence = _.get(
        state.templateFields[fieldIndex],
        "displaySequence"
      );
      const updatedField = { ...field, displaySequence };
      if (fieldIndex === -1) return state;

      return update(state, {
        templateFields: {
          [fieldIndex]: { $set: updatedField },
        },
      });
    }
    case ADD_NEW_OPTION: {
      const { id: fieldId } = payload;

      const fieldIndex = _.findIndex(
        state.templateFields,
        field => field.id === fieldId
      );
      if (fieldIndex === -1) return state;

      const valuesPath = `templateFields[${fieldIndex}].dataSet.values`;
      const existingValues = _.get(state, valuesPath, []);
      const newValuesArray = Array.isArray(existingValues)
        ? existingValues
        : [];
      const lastDisplaySequence =
        _.maxBy(newValuesArray, "displaySequence")?.displaySequence || 0;
      const newDisplaySequence = lastDisplaySequence + 1;

      const newValueEntry = {
        displaySequence: newDisplaySequence,
        value: "",
      };

      if (!_.size(existingValues)) {
        return update(state, {
          templateFields: {
            [fieldIndex]: {
              dataSet: {
                values: { $set: [newValueEntry] },
              },
            },
          },
        });
      }

      return update(state, {
        templateFields: {
          [fieldIndex]: {
            dataSet: {
              values: { $push: [newValueEntry] },
            },
          },
        },
      });
    }

    case UPDATE_OPTION_VALUE: {
      const { fieldId, displaySequence, value } = payload;
      const fieldIndex = _.findIndex(
        state.templateFields,
        field => field.id === fieldId
      );
      if (fieldIndex === -1) return state;

      const optionIndex = _.findIndex(
        _.get(state.templateFields[fieldIndex], "dataSet.values", []),
        option => option.displaySequence === displaySequence
      );
      if (optionIndex === -1) return state;
      return update(state, {
        templateFields: {
          [fieldIndex]: {
            dataSet: {
              values: {
                [optionIndex]: {
                  value: { $set: value },
                },
              },
            },
          },
        },
      });
    }
    case UPDATE_OPTIONS: {
      const { fieldId, values } = payload;
      const fieldIndex = _.findIndex(
        state.templateFields,
        field => field.id === fieldId
      );

      if (fieldIndex === -1) return state;
      return update(state, {
        templateFields: {
          [fieldIndex]: {
            dataSet: {
              values: { $set: values },
            },
          },
        },
      });
    }
    case DELETE_OPTION: {
      const { fieldId, displaySequence } = payload;

      const fieldIndex = _.findIndex(
        state.templateFields,
        field => field.id === fieldId
      );
      if (fieldIndex === -1) return state;
      const valuesPath = `templateFields[${fieldIndex}].dataSet.values`;
      const existingValues = _.get(state, valuesPath, []);
      const filteredValues = existingValues.filter(
        value => value.displaySequence !== displaySequence
      );
      const updatedValues = filteredValues.map((value, index) => ({
        ...value,
        displaySequence: index + 1,
      }));
      return update(state, {
        templateFields: {
          [fieldIndex]: {
            dataSet: {
              values: { $set: updatedValues },
            },
          },
        },
      });
    }

    case UPDATE_FIELD_ENTITIES: {
      const { id: fieldId, ...otherEntities } = payload;

      const fieldIndex = _.findIndex(
        state.templateFields,
        field => field.id === fieldId
      );

      if (fieldIndex === -1) return state;
      return update(state, {
        templateFields: {
          [fieldIndex]: {
            $merge: otherEntities,
          },
        },
      });
    }

    case UPDATE_METADATA: {
      const { id: fieldId, ...otherEntities } = payload;

      const fieldIndex = _.findIndex(
        state.templateFields,
        field => field.id === fieldId
      );

      if (fieldIndex === -1) return state;

      return update(state, {
        templateFields: {
          [fieldIndex]: {
            metadata: {
              $set: {
                ..._.get(state.templateFields[fieldIndex], "metadata", {}),
                ...otherEntities,
              },
            },
          },
        },
      });
    }

    case UPDATE_FIELD_DATASET: {
      const { id: fieldId, ...dataSetFields } = payload;

      const fieldIndex = _.findIndex(
        state.templateFields,
        field => field.id === fieldId
      );

      if (fieldIndex === -1) return state;
      return update(state, {
        templateFields: {
          [fieldIndex]: {
            dataSet: {
              $merge: dataSetFields,
            },
          },
        },
      });
    }

    case DELETE_FIELD: {
      const { fieldId } = payload;

      const updatedFields = _.filter(
        state.templateFields,
        field => field.id !== fieldId
      );

      const reOrderedFields = _.map(updatedFields, (field, index) => ({
        ...field,
        displaySequence: index + 1,
      }));

      return update(state, {
        templateFields: { $set: reOrderedFields },
      });
    }

    case SWAP_FEILDS: {
      const { prevDisplaySequence, updatedDisplaySequence } = payload;

      const currentFieldIndex = _.findIndex(
        state.templateFields,
        field => _.get(field, "displaySequence") === prevDisplaySequence
      );

      const nextFieldIndex = _.findIndex(
        state.templateFields,
        field => _.get(field, "displaySequence") === updatedDisplaySequence
      );

      if (currentFieldIndex === -1 || nextFieldIndex === -1) return state;

      return update(state, {
        templateFields: {
          [currentFieldIndex]: {
            displaySequence: { $set: updatedDisplaySequence },
          },
          [nextFieldIndex]: {
            displaySequence: { $set: prevDisplaySequence },
          },
        },
      });
    }
    case RESET_TEMPLATE: {
      return update(state, {
        templateFields: {
          $set: [],
        },
      });
    }
    case UPDATE_MEAL_MENUS: {
      const { id: fieldId, menus } = payload;
      const fieldIndex = _.findIndex(
        state.templateFields,
        field => field.id === fieldId
      );

      if (fieldIndex === -1) return state;
      return update(state, {
        mealMenus: {
          $set: {
            [fieldId]: menus,
          },
        },
        templateFields: {
          [fieldIndex]: {
            dataSetIds: {
              $set: _.map(menus, menu => _.get(menu, "id")),
            },
          },
        },
      });
    }

    case DELETE_MEAL_MENU: {
      const { fieldId } = payload;
      const fieldIndex = _.findIndex(
        state.templateFields,
        field => field.id === fieldId
      );

      if (fieldIndex === -1) return state;

      return update(state, {
        mealMenus: {
          $unset: [fieldId],
        },
        templateFields: {
          [fieldIndex]: {
            dataSetIds: {
              $set: [],
            },
          },
        },
      });
    }
    default: {
      return state;
    }
  }
};

const REDUCER_HANDLERS = {
  [UPDATE_FILTERS]: (state, action) => {
    const filters = action.data;
    state = update(state, {
      filters: { $set: { ...state.filters, ...filters } },
    });
    return state;
  },
  [UPDATE_CLASSES]: (state, action) => {
    const mappingsData = action.data;
    state = update(state, {
      mappings: { $set: { ...state.mappings, ...mappingsData } },
    });
    return state;
  },
  [SET_ALL_CLASSES_SELECTED]: (state, action) => {
    const isAllClassesSelected = action.data;
    return { ...state, isAllClassesSelected };
  },
  [RESET_FILTERS]: state => {
    state = update(state, {
      filters: {
        $set: {
          searchText: "",
          grades: [],
        },
      },
    });
    return state;
  },
  [RESET_CLASSES]: state => {
    return update(state, {
      mappings: {
        classes: { $set: [] },
      },
    });
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
